import { useState } from "react";
import { useIntl } from "react-intl";
import { Spin } from "antd";
import {
  IoCheckmarkCircle,
  IoTimeOutline,
  IoPrintOutline,
} from "react-icons/io5";
import {
  StyledModal,
  ModalContent,
  CheckIconContainer,
  Title,
  CollaboratorInfoContainer,
  CollaboratorName,
  InfoRow,
  InfoLabel,
  InfoValue,
  PrintQuestionContainer,
  PrintQuestion,
  ButtonsContainer,
  ButtonPrintLater,
  ButtonPrintNow,
} from "./styles";

export default function ModalAssociateSuccess({
  visible,
  onCancel,
  onConfirm,
  viewCard = false,
  loadingPrint = false,
}) {
  const intl = useIntl();

  return (
    <StyledModal
      closable={false}
      open={visible}
      destroyOnClose={true}
      width={700}
      footer={null}
    >
      <ModalContent>
        <CheckIconContainer>
          <IoCheckmarkCircle />
        </CheckIconContainer>

        <Title>{intl.formatMessage({ id: "collaborator_associated" })}</Title>

        {viewCard && (
          <CollaboratorInfoContainer>
            <CollaboratorName>Name</CollaboratorName>

            <InfoRow>
              <InfoLabel>{intl.formatMessage({ id: "position" })}:</InfoLabel>
              <InfoValue>Position</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>{intl.formatMessage({ id: "department" })}:</InfoLabel>
              <InfoValue>Department</InfoValue>
            </InfoRow>

            <InfoRow>
              <InfoLabel>{intl.formatMessage({ id: "email" })}:</InfoLabel>
              <InfoValue>Email</InfoValue>
            </InfoRow>
          </CollaboratorInfoContainer>
        )}

        <PrintQuestionContainer>
          <PrintQuestion>
            {intl.formatMessage({ id: "print_credential_now_question" })}
          </PrintQuestion>
        </PrintQuestionContainer>

        <ButtonsContainer>
          <ButtonPrintLater onClick={onCancel} disabled={loadingPrint}>
            <IoTimeOutline />
            {intl.formatMessage({ id: "print_later" })}
          </ButtonPrintLater>

          <ButtonPrintNow onClick={onConfirm} disabled={loadingPrint}>
            {loadingPrint ? (
              <Spin size="small" />
            ) : (
              <>
                <IoPrintOutline />
                {intl.formatMessage({ id: "print_now" })}
              </>
            )}
          </ButtonPrintNow>
        </ButtonsContainer>
      </ModalContent>
    </StyledModal>
  );
}
